import { Link } from "react-router-dom";

interface BlogArticle {
  slug: string;
  tag: string;
  title: string;
  excerpt: string;
  image: string;
}

const articles: BlogArticle[] = [
  {
    slug: "/what-is-gtbuy-spreadsheet",
    tag: "Beginner Guide",
    title: "What is GTBuy Spreadsheet? Complete Beginner Guide",
    excerpt:
      "Learn how GTBuy Spreadsheet works, why ecommerce sellers use it for sourcing optimization, and how to get started with a structured supplier comparison system.",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20minimalist%20laptop%20on%20light%20oak%20desk%20displaying%20colorful%20spreadsheet%20with%20charts%20and%20product%20data%20tables%20ceramic%20coffee%20mug%20and%20notebook%20beside%20it%20soft%20morning%20sunlight%20streaming%20through%20window%20modern%20workspace%20photography%20bright%20airy%20atmosphere%20high%20detail%20editorial&width=800&height=500&seq=blog-card-v2-01&orientation=landscape",
  },
  {
    slug: "/gtbuy-vs-kakobuy",
    tag: "Comparison",
    title: "GTBuy Spreadsheet vs Kakobuy Spreadsheet — Full Comparison",
    excerpt:
      "A detailed head-to-head comparison of GTBuy and Kakobuy spreadsheet systems. See which sourcing tool delivers better structure, speed, and scalability for your ecommerce business.",
    image:
      "https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20with%20two%20laptops%20side%20by%20side%20on%20marble%20desk%20each%20showing%20different%20spreadsheet%20interfaces%20with%20colorful%20data%20points%20green%20plant%20in%20center%20bright%20modern%20office%20setting%20clean%20professional%20photography%20high%20detail&width=800&height=500&seq=blog-card-v2-02&orientation=landscape",
  },
  {
    slug: "/gtbuy-vs-superbuy",
    tag: "Comparison",
    title: "GTBuy Spreadsheet vs Superbuy Spreadsheet — Which is Better?",
    excerpt:
      "Compare GTBuy and Superbuy spreadsheet sourcing systems side by side. We break down data handling, transparency, automation features, and real-world usability for online sellers.",
    image:
      "https://readdy.ai/api/search-image?query=Two%20tablets%20displaying%20spreadsheet%20dashboards%20on%20minimalist%20white%20desk%20with%20coffee%20cup%20and%20eyeglasses%20overhead%20flatlay%20perspective%20comparing%20data%20visualizations%20soft%20neutral%20lighting%20clean%20contemporary%20business%20photography%20crisp%20editorial%20style&width=800&height=500&seq=blog-card-v2-03&orientation=landscape",
  },
  {
    slug: "/best-sourcing-tools",
    tag: "Guide",
    title: "Best Sourcing Spreadsheet Tools for Ecommerce Sellers",
    excerpt:
      "Discover the top spreadsheet-based sourcing tools for online store owners. We rank and review systems by ease of use, scalability, and value for dropshippers and wholesalers.",
    image:
      "https://readdy.ai/api/search-image?query=Desktop%20workspace%20with%20large%20monitor%20showing%20supplier%20comparison%20matrix%20with%20color%20coded%20cells%20keyboard%20mouse%20and%20smartphone%20on%20warm%20wooden%20desk%20modern%20office%20with%20bookshelf%20background%20natural%20lighting%20professional%20productivity%20photography%20detailed%20editorial&width=800&height=500&seq=blog-card-v2-04&orientation=landscape",
  },
  {
    slug: "/improve-profit-margins",
    tag: "Strategy",
    title: "How GTBuy Spreadsheet Improves Ecommerce Profit Margins",
    excerpt:
      "Learn how structured sourcing with GTBuy Spreadsheet directly boosts your bottom line. Data-driven strategies for reducing supplier costs and maximizing per-unit profitability.",
    image:
      "https://readdy.ai/api/search-image?query=Financial%20growth%20concept%20with%20laptop%20displaying%20upward%20trending%20revenue%20charts%20and%20profit%20margin%20graphs%20calculator%20and%20notepad%20with%20handwritten%20notes%20on%20light%20wood%20desk%20warm%20afternoon%20sunlight%20positive%20business%20photography%20optimistic%20tone%20high%20detail&width=800&height=500&seq=blog-card-v2-05&orientation=landscape",
  },
  {
    slug: "/how-to-use-gtbuy",
    tag: "Tutorial",
    title: "How to Use GTBuy Spreadsheet — Step-by-Step Guide",
    excerpt:
      "A practical walkthrough for setting up and using the GTBuy Spreadsheet system. Follow clear steps to organize supplier data, compare pricing, and optimize your sourcing workflow.",
    image:
      "https://readdy.ai/api/search-image?query=Hands%20typing%20on%20laptop%20keyboard%20with%20spreadsheet%20template%20visible%20on%20screen%20showing%20product%20columns%20and%20supplier%20rows%20sticky%20notes%20and%20pen%20on%20desk%20warm%20overhead%20lighting%20focused%20work%20photography%20step%20by%20step%20guide%20concept%20high%20detail%20editorial&width=800&height=500&seq=blog-card-v2-06&orientation=landscape",
  },
  {
    slug: "/dropshipping-sourcing-system",
    tag: "Guide",
    title: "Dropshipping Sourcing System Explained — Spreadsheet Method",
    excerpt:
      "Understand how a spreadsheet-based dropshipping sourcing system works. Learn the framework that replaces chaotic supplier management with a clean, repeatable process.",
    image:
      "https://readdy.ai/api/search-image?query=Ecommerce%20dropshipping%20concept%20with%20laptop%20showing%20online%20store%20dashboard%20and%20spreadsheet%20side%20by%20side%20packaging%20boxes%20and%20shipping%20labels%20on%20desk%20modern%20workspace%20with%20exposed%20brick%20wall%20warm%20industrial%20lighting%20professional%20product%20photography%20high%20detail&width=800&height=500&seq=blog-card-v2-07&orientation=landscape",
  },
  {
    slug: "/why-use-spreadsheet-sourcing",
    tag: "Insights",
    title: "Why Ecommerce Sellers Use Spreadsheet Sourcing Systems",
    excerpt:
      "Explore why successful online store owners are switching to structured spreadsheet systems. The benefits of organized data, faster decisions, and reduced sourcing errors.",
    image:
      "https://readdy.ai/api/search-image?query=Creative%20workspace%20with%20large%20monitor%20displaying%20organized%20spreadsheet%20data%20alongside%20analog%20planner%20and%20colorful%20markers%20organized%20desk%20with%20minimalist%20decor%20potted%20snake%20plant%20bright%20natural%20light%20from%20large%20window%20productive%20atmosphere%20editorial%20photography%20high%20detail&width=800&height=500&seq=blog-card-v2-08&orientation=landscape",
  },
  {
    slug: "/reduce-sourcing-costs",
    tag: "Strategy",
    title: "How to Reduce Sourcing Costs Using GTBuy Spreadsheet",
    excerpt:
      "Practical methods to cut your product sourcing expenses with the GTBuy system. Learn price comparison tactics, bulk negotiation strategies, and supplier performance tracking.",
    image:
      "https://readdy.ai/api/search-image?query=Cost%20reduction%20visualization%20with%20laptop%20showing%20descending%20cost%20charts%20and%20savings%20calculator%20spreadsheet%20piggy%20bank%20and%20coins%20on%20minimalist%20white%20desk%20green%20plant%20for%20growth%20symbolism%20bright%20optimistic%20lighting%20business%20finance%20photography%20high%20detail%20editorial&width=800&height=500&seq=blog-card-v2-09&orientation=landscape",
  },
  {
    slug: "/gtbuy-spreadsheet-review",
    tag: "Review",
    title: "GTBuy Spreadsheet Review 2026 — Is It Worth It?",
    excerpt:
      "An honest, detailed review of the GTBuy Spreadsheet system. We cover pros and cons, real user experiences, and whether this sourcing methodology is right for your store.",
    image:
      "https://readdy.ai/api/search-image?query=Review%20and%20rating%20concept%20with%20laptop%20displaying%20five%20star%20rating%20interface%20and%20detailed%20spreadsheet%20analysis%20alongside%20coffee%20and%20reading%20glasses%20on%20warm%20wooden%20desk%20cozy%20home%20office%20setting%20with%20books%20in%20background%20soft%20warm%20lighting%20trustworthy%20editorial%20photography&width=800&height=500&seq=blog-card-v2-10&orientation=landscape",
  },
];

export default function BlogPreview() {
  return (
    <section id="shopping-guides" className="w-full bg-background-100 py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-3">
            Sourcing Guides
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-2">
            Learn &amp; Optimize
          </h2>
          <p className="text-sm text-foreground-600 max-w-md">
            Practical guides and tips to improve your ecommerce sourcing workflow
            with spreadsheet-based systems. 10 in-depth articles to level up your sourcing game.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/10] w-full overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-xs text-primary-600 font-medium uppercase tracking-wider mb-2">
                  {article.tag}
                </span>
                <h3 className="font-heading text-lg text-foreground-950 mb-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  Read Article <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}